import { HotelDealTile } from "./HotelDealTile";
import type { TravelDeal } from "./useTravelDeals";
import {
  HtsMediaClaimedDealTile,
  HtsMediaDealTile,
} from "@/modules/htsMedia/HtsMediaDealTile";
import type { OfferScreen } from "@/tracking/offers";

/** Renders a `TravelDeal` with the matching tile implementation. */
export const TravelDealTile = ({
  deal,
  tileIndex,
  screen,
}: {
  deal: TravelDeal;
  tileIndex: number;
  /** Surface the tile renders on; segments the offer events. */
  screen: OfferScreen;
}) =>
  deal.kind === "claimed" ? (
    <HtsMediaClaimedDealTile
      offer={deal.offer}
      tileIndex={tileIndex}
      screen={screen}
    />
  ) : deal.kind === "sponsored" ? (
    <HtsMediaDealTile ad={deal.ad} tileIndex={tileIndex} screen={screen} />
  ) : (
    <HotelDealTile
      tile={deal.tile}
      imageUrl={deal.tile.image?.x1 ?? ""}
      tileIndex={tileIndex}
    />
  );
